"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _UpdateSiteSettings = _interopRequireDefault(require("../stagedObjects/UpdateSiteSettings"));

var _ContentMembershipSettingsContainer = _interopRequireDefault(require("./ContentMembershipSettingsContainer"));

var ContentMembershipSettingsWrapper =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ContentMembershipSettingsWrapper, _PureComponent);

  function ContentMembershipSettingsWrapper() {
    (0, _classCallCheck2.default)(this, ContentMembershipSettingsWrapper);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContentMembershipSettingsWrapper).apply(this, arguments));
  }

  (0, _createClass2.default)(ContentMembershipSettingsWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          numberOfStagedChanges = _this$props.numberOfStagedChanges,
          siteSettingsForSaving = _this$props.siteSettingsForSaving;
      return _react.default.createElement("div", {
        className: "p-bottom-10",
        "data-test-id": "content-membership-settings"
      }, _react.default.createElement(_ContentMembershipSettingsContainer.default, {
        stageForEdit: this.props.stageForEdit,
        resetChanges: this.props.resetChanges,
        numberOfStagedChanges: numberOfStagedChanges,
        siteSettingsForSaving: siteSettingsForSaving
      }, children));
    }
  }]);
  return ContentMembershipSettingsWrapper;
}(_react.PureComponent);

ContentMembershipSettingsWrapper.propTypes = {
  children: _react.PropTypes.node.isRequired,
  stageForEdit: _react.PropTypes.func.isRequired,
  resetChanges: _react.PropTypes.func.isRequired,
  siteSettingsForSaving: _react.PropTypes.object.isRequired,
  numberOfStagedChanges: _react.PropTypes.number.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    numberOfStagedChanges: _UpdateSiteSettings.default.numberOfChanges(state),
    siteSettingsForSaving: _UpdateSiteSettings.default.getStagedObject(state)
  };
};

var mapDispatchToProps = {
  resetChanges: _UpdateSiteSettings.default.resetChangesToStagedObject,
  stageForEdit: _UpdateSiteSettings.default.stageForEdit
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContentMembershipSettingsWrapper);

exports.default = _default;
module.exports = exports.default;